import { render, staticRenderFns } from "./IcoMyCompetencyProfile.vue?vue&type=template&id=04d2102f"
import script from "./IcoMyCompetencyProfile.vue?vue&type=script&lang=js"
export * from "./IcoMyCompetencyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports